import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import TranslationService from '../translations';
import dtmTags from '../common/dtmTags';
import ErrorContainer from '../common/components/ErrorContainer';
import { DataDtmActions } from '../common/Constants';
import BigCircleSpinner from '../common/components/BigCircleSpinner';
import ProducerService from '../profile/api/ProducerService';
import Utils from '../common/Utils';
import ProducerMapper from '../common/producer/ProducerMapper';
import ProductCarouselWrapper from '../profile/exhibitorPage/products/ProductCarouselWrapper';
import ProducerDetailsImage from './ProducerDetailsImage';
import StringFormatter from '../common/StringFormatter';

class ProducerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      profileImage: '',
      firstName: '',
      description: '',
      lastName: '',
      products: [],
      isLoading: true,
      errors: [],
      fieldErrors: {},
      representingCompanies: [],
      exhibitingCompanies: []
    };
  }

  componentDidMount() {
    ProducerService.getProducerDetails(this.props.baseApiUrl, this.props.context.artistId, this.props.context.interfaceLocale).then((response) => {
      if (Utils.serviceResultHasError(response)) {
        this.setState({
          ...response,
          isLoading: false
        });
        return;
      }
      const mappedProducerDetails = ProducerMapper.fromProducerResponse(
        response,
        this.props.context.interfaceLocale, this.props.context.primaryLocale
      );
      this.setState({
        ...mappedProducerDetails,
        isLoading: false
      });
    });
  }
  displayLinkedCompanies = (linkedCompanies, title, tag) => (
    linkedCompanies.length !== 0 &&
      <div className={Classes.linkedExhibitorTitle}>
        <p>{title}</p>
        <div>{
      linkedCompanies.map(linkedCompany => (
        <div
          className={Classes.linkedExhibitorName}
        >
          <a
            data-dtm={tag}
            data-dtm-attributes={JSON.stringify({ exhibitingOrganisationId: linkedCompany.id, producerId: this.props.context.artistId })}
            href={StringFormatter.format(
        this.props.navigation.exhibitorPublicDetailsUrlFormat,
        linkedCompany.organisationId
      )}
          >{linkedCompany.displayName}
          </a>
        </div>))
      }
        </div>
      </div>)

  render() {
    const {
      firstName, lastName, description, profileImage, products, id, errors, isLoading, fieldErrors, exhibitingCompanies, representingCompanies
    } = this.state;
    const {
      navigation, context, assets
    } = this.props;

    const translations = TranslationService.getTranslations(context.interfaceLocale);
    const producerDetailsTranslations = TranslationService.getTranslations(context.interfaceLocale).producerDetails;
    const tags = dtmTags.producerDetails;
    if (errors.length > 0) {
      return <ErrorContainer errors={errors} />;
    }
    if (Object.keys(fieldErrors).length > 0) {
      return <ErrorContainer errors={[translations.errorMessages.client_error]} />;
    }
    if (isLoading) {
      return <BigCircleSpinner />;
    }
    return (
      <Fragment>
        <div
          data-dtm={tags.section}
          data-dtm-actions={DataDtmActions.view}
          data-dtm-attributes={JSON.stringify({ producerId: id })}
        >
          <ProducerDetailsImage
            producerId={id}
            tag={tags.producerImage}
            src={profileImage}
            alt={producerDetailsTranslations.producerImageAltText}
            defaultArtistLogoUrl={assets.defaultArtistLogoUrl || assets.defaultParticipantPhotoUrl}
            defaultArtistLogoMobileUrl={assets.defaultArtistLogoMobileUrl || assets.defaultParticipantPhotoMobileUrl}
            isRounded
          />
          <hr />
          <div>
            <div className={Classes.producerTitle}>{firstName} {lastName}</div>
          </div>
          {description ? <div className={Classes.producerDescription}>{description}</div> : null}
          {(exhibitingCompanies.length !== 0 || representingCompanies.length !== 0) && <hr />}
          {this.displayLinkedCompanies(
          exhibitingCompanies,
          producerDetailsTranslations.associatedExhibitors.exhibiting, tags.producerExhibitingCompany
        )}
          {this.displayLinkedCompanies(
          representingCompanies,
          producerDetailsTranslations.associatedExhibitors.representing, tags.producerRepresentingCompany
        )}
          <ProductCarouselWrapper
            products={products}
            tags={tags.productCarousel}
            productDetailsUrlFormat={navigation.productDetailsUrlFormat}
            interfaceLocale={context.interfaceLocale}
            productCarouselLabel={producerDetailsTranslations.productCarouselLabel}
          />
        </div>
      </Fragment>);
  }
}

ProducerDetails.propTypes = {
  baseApiUrl: PropTypes.string.isRequired,
  context: PropTypes.shape({
    artistId: PropTypes.string.isRequired,
    interfaceLocale: PropTypes.string.isRequired,
    primaryLocale: PropTypes.string.isRequired
  }).isRequired,
  navigation: PropTypes.object.isRequired,
  assets: PropTypes.shape({
    defaultArtistLogoUrl: PropTypes.string,
    defaultArtistLogoMobileUrl: PropTypes.string,
    defaultParticipantPhotoMobileUrl: PropTypes.string,
    defaultParticipantPhotoUrl: PropTypes.string
  }).isRequired
};


export default ProducerDetails;
